export default "__VITE_ASSET__afgNHQaM__"